var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 12.5C14.71 12.5 16.5 10.71 16.5 8.5C16.5 6.29 14.71 4.5 12.5 4.5C10.29 4.5 8.5 6.29 8.5 8.5C8.5 10.71 10.29 12.5 12.5 12.5ZM12.5 14.5C9.83 14.5 4.5 15.84 4.5 18.5V20.5H20.5V18.5C20.5 15.84 15.17 14.5 12.5 14.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.f4d68a3f4df9c593d362d3945183a5cf.svg";
export { ForwardRef as ReactComponent };